export default "__VITE_ASSET__CPWFge9M__"